import { useTranslation } from "react-i18next";
import moment from "moment";
import { Label } from "../../../../helpers/historyHelpers/components/Label";
import { OldValue } from "../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../helpers/historyHelpers/components/NewValue";
import { firstToUpper } from "../../../../../../utils/helpers/string";
import { useCompanyDateFormat } from "../../../../../../utils/hooks/company";

const fields = [
    "country",
    "description",
    "periodEndDate",
    "periodStartDate",
    "time",
    "timeSheetLockDate",
    "status",
];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat() || "MM/DD/YYYY";

    if (!data) return null;

    const renderValues = (item, data) => {
        const newValue = data[item]?.new;
        const oldValue = data[item]?.old;

        switch (item) {
            case "status":
                return (
                    <>
                        {oldValue && <OldValue value={firstToUpper(t(oldValue))} />}
                        {newValue && <NewValue value={firstToUpper(t(newValue))} />}
                    </>
                );
            case "description":
            case "timeSheetLockDate":
                return (
                    <>
                        {oldValue && <OldValue value={oldValue} />}
                        {newValue && <NewValue value={newValue} />}
                    </>
                );
            case "country":
                return (
                    <>
                        {oldValue && <OldValue value={oldValue.name} />}
                        {newValue && <NewValue value={newValue.name} />}
                    </>
                );
            case "periodStartDate":
            case "periodEndDate":
            case "time":
                return (
                    <>
                        {oldValue && <OldValue value={moment.parseZone(oldValue).format(dateFormat)} />}
                        {newValue && <NewValue value={moment.parseZone(newValue).format(dateFormat)} />}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields?.map((item) => {
                if (!data[item]) return null;

                return (
                    <div key={item}>
                        <div className="py-1 d-flex align-items-center gap-2">
                            <Label value={t(item)} /> {renderValues(item, data)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
